export const FETCH_END = "setArticles";
export const FETCH_START = "setLoading";
export const PURGE_AUTH = "logOut";
export const SET_COLLECTION = "setCollection";
export const SET_EXPCLIENT_COLLECTIONS = "setCollections";
export const ALTER_COLLECTIONS_COLECTION = "alterCollectionsCollection";

export const REMOVE_COLLECTION = "removeCollection";

export const SET_SHOW_FILTERS = "setShowFilters";

export const SET_LOADING_STATE = "setLoadingState";
export const SET_SEARCH_IDENTIFIER = "setSearchIdentifier";
export const SET_SEARCH_QUERY = "setSearchQuery";
export const SET_PHOTO_SEARCH_RESULT = "setPhotoSearchResult";
export const RESET_SEARCH = "resetSearch";
export const SET_PHOTO_RESULT_ITEM = "setPhotoSearchResultItem";
export const SET_PHOTO_RESULT_SET_PUBLISH_STATE = "setPhotoPublishState";

export const RESET_STATE_PHOTO_ITEM = "resetPhotoStateItem";

export const SET_ALL_SELECT_PHOTO_ADD = "selectAll";
export const SET_ALL_SELECT_PHOTO_REMOVE = "deSelectAll";
export const SET_SELECT_PHOTO_REMOVE = "removeItemFromAddList";
export const SET_SELECT_PHOTO_ADD = "addItemFromAddList";
export const RESET_STATE_ITEM = "resetStateItem";

export const SET_SHOW_SELECTED = "setShowSelected";

export const SET_ACTIVE_COMP = "setActiveComponent";

export const SET_AUTH = "setUser";

export const SET_EXPCLIENT = "setExpCLient";
export const SET_EXPCLIENT_ID = "setExpCLientId";
export const SET_EXPCLIENT_LIST = "setExpCLientList";

export const SET_ERROR = "setError";
export const RESET_STATE = "resetModuleState";
// export const SET_COMMENTS = "setComments";


// export const SET_PROFILE = "setProfile";
// export const SET_TAGS = "setTags";
// export const TAG_ADD = "addTag";
// export const TAG_REMOVE = "removeTag";
// export const UPDATE_COLLECTION_IN_LIST = "updateCollectionInList";

